export const LOADING_FLAG = 'loading_flag'
